import { snakecase } from '@zoopla/strings';

export const snakeCaseKeys = (obj: Record<string, unknown>) => {
    return Object.entries(obj).reduce(
        (acc: Record<string, unknown>, [key, value]) => ({
            ...acc,
            [snakecase(key)]: value
        }),
        {}
    );
};

export const removePropertiesWithNullishValues = (
    obj: Record<string, unknown>
) => {
    return Object.entries(obj).reduce(
        (acc: Record<string, unknown>, [key, value]) => {
            if (value === null || value === undefined) return acc;
            return {
                ...acc,
                [key]: value
            };
        },
        {}
    );
};
